(function () {
  var html = document.documentElement;
  var sheets = [];

  var cartRoot = document.querySelector("[data-cart-drawer]");
  if (cartRoot) {
    sheets.push({
      panel: cartRoot.querySelector("[data-cart-panel]"),
      dragFrom: cartRoot.querySelector(".cart-drawer__handle"),
      isOpen: function () { return cartRoot.dataset.state === "open"; },
      close: function () {
        var btn = cartRoot.querySelector("[data-cart-minimize]");
        if (btn) btn.click();
      }
    });
  }

  var sizeSheet = document.querySelector("[data-mobile-size-sheet]");
  if (sizeSheet) {
    sheets.push({
      panel: sizeSheet.querySelector(".mobile-size-sheet__panel"),
      dragFrom: sizeSheet.querySelector(".mobile-size-sheet__header"),
      isOpen: function () { return sizeSheet.dataset.state === "open"; },
      close: function () {
        var btn = sizeSheet.querySelector("[data-mobile-size-sheet-close]");
        if (btn) btn.click();
      }
    });
  }

  if (!sheets.length) return;

  function isMobile() {
    return window.matchMedia ? window.matchMedia("(max-width: 760px)").matches : window.innerWidth <= 760;
  }

  sheets.forEach(function (sheet) {
    if (!sheet.panel || !sheet.dragFrom) return;
    var startY = 0, currentY = 0, dragging = false;
    sheet.dragFrom.style.touchAction = "none";

    function onDown(e) {
      if (!isMobile() || !sheet.isOpen()) return;
      dragging = true;
      startY = e.touches ? e.touches[0].clientY : e.clientY;
      currentY = startY;
      sheet.panel.style.transition = "none";
    }
    function onMove(e) {
      if (!dragging) return;
      currentY = e.touches ? e.touches[0].clientY : e.clientY;
      var dy = Math.max(0, currentY - startY);
      sheet.panel.style.transform = "translateY(" + dy + "px)";
      if (e.cancelable) e.preventDefault();
    }
    function onUp() {
      if (!dragging) return;
      dragging = false;
      var dy = Math.max(0, currentY - startY);
      sheet.panel.style.transition = "";
      sheet.panel.style.transform = "";
      if (dy > 96) sheet.close();
    }

    sheet.dragFrom.addEventListener("touchstart", onDown, { passive: true });
    window.addEventListener("touchmove", onMove, { passive: false });
    window.addEventListener("touchend", onUp);
    sheet.dragFrom.addEventListener("mousedown", onDown);
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  });

  var lastFocused = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function activePanel() {
    for (var i = 0; i < sheets.length; i++) {
      if (sheets[i].isOpen()) return sheets[i].panel;
    }
    return null;
  }

  function trapTab(e) {
    if (e.key !== "Tab") return;
    var panel = activePanel();
    if (!panel) return;
    var nodes = Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (n) {
      return n.offsetParent !== null;
    });
    if (!nodes.length) return;
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }
  document.addEventListener("keydown", trapTab);

  var observer = new MutationObserver(function () {
    var panel = activePanel();
    if (panel) {
      if (!lastFocused) lastFocused = document.activeElement;
      var target = panel.querySelector(FOCUSABLE);
      if (target && isMobile()) {
        setTimeout(function () {
          try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
        }, 60);
      }
    } else if (lastFocused) {
      var toRestore = lastFocused;
      lastFocused = null;
      setTimeout(function () { try { toRestore.focus({ preventScroll: true }); } catch (err) {} }, 0);
    }
  });
  observer.observe(html, { attributes: true, attributeFilter: ["class"] });
})();
